export const SbTabPanelContext = Symbol('SbTabPanelContext')
